import { useRentalManagerUserPropertyMultiplexWebApiHandler_overview } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import useMultiplexBuildingSessionId from './useMultiplexBuildingSessionId';

/**
 * Fetches multiplex building-session overview for the modular listing flow.
 */
const useMultiplexOverview = () => {
  const { multiplexBuildingSessionId } = useMultiplexBuildingSessionId();

  const { data, error, isFetching } = useRentalManagerUserPropertyMultiplexWebApiHandler_overview(
    { multiplexBuildingSessionId: multiplexBuildingSessionId ?? '' },
    {
      enabled: Boolean(multiplexBuildingSessionId),
      meta: {
        tags: multiplexBuildingSessionId
          ? ['multiplexBuildingSessionOverview', multiplexBuildingSessionId]
          : ['multiplexBuildingSessionOverview'],
        context: {
          api: 'useRentalManagerUserPropertyMultiplexWebApiHandler_overview',
          details: 'useMultiplexOverview',
        },
      },
    },
  );

  return {
    data,
    isFetching,
    error,
  };
};

export default useMultiplexOverview;
